<template>
  <v-container fluid class="invoice-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-district`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-home-city</v-icon>
            District
          </v-tab>
          <v-tab-item
            :value="'tab-district'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit District</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeDistrict($event, 'districtcode')"
                        v-bind:value="initvalue.districtcode"
                        placeholder="Town Code"
                        persistent-hint
                        single-line hint="Enter the district code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeDistrict($event, 'districtname')"
                        v-bind:value="initvalue.districtname"
                        placeholder="Town Name"
                        persistent-hint
                        single-line hint="Enter the district name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeDistrict($event, 'districtinfo')"
                        v-bind:value="initvalue.districtinfo"
                        placeholder="Info Text"
                        persistent-hint
                        single-line hint="Enter the info text">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=districttypes
                        :value="initvalue.districttype"
                        outlined
                        dense
                        v-on:change="onChangeDistrict($event, 'districttype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the district type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="regions.map(x => {
                            return {text: x.regionname, value: x._id};
                          })"
                        :value="edit_district.regionid"
                        outlined
                        dense
                        v-on:change="onChangeDistrict($event, 'regionid')"
                        v-model="edit_district.regionid"
                        placeholder="Region"
                        persistent-hint
                        single-line hint="Please choose the region">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="townships.filter(x=>x.regionid==edit_district.regionid).map(x => {
                            return {text: x.townshipname, value: x._id};
                          })"
                        
                        :value="initvalue.townshipid"
                        outlined
                        dense
                        v-on:change="onChangeDistrict($event, 'townshipid')"
                        placeholder="Township"
                        persistent-hint
                        single-line hint="Please choose the township">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeDistrict($event, 'districtstatus')"
                          v-bind:label="change_district.districtstatus"
                          v-bind:value="initvalue.districtstatus"
                          v-model="change_district.districtstatus"
                          true-value="Active"
                          false-value="Inactive"
                      ></v-switch>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                        <v-col cols="12" md="6">
                          <div class="d-flex justify-center">
                            <v-btn
                                to="/district/list"
                                replace
                                outlined
                                color="primary"
                            >
                              Cancel
                            </v-btn>
                            <v-spacer></v-spacer>
                              <v-btn
                                :loading="isReceiving"
                                class="button-shadow"
                                color="primary"
                                @click="editDistrict()">
                                Save
                              </v-btn>
                          </div>
                        </v-col>
                      </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      edit_district: {},
      change_district: {},
      initvalue: {},
      districttypes: ['District', 'Neighborhood', 'Commune'],
    }
  },
  methods: {
    
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('Township', ['getTownshipsRequest']),
    ...mapActions('District', ['updateDistrictRequest','getDistrictsRequest']),
    async editDistrict() {
      this.change_district._id = this.initvalue._id;
      this.edit_district = Object.assign({}, this.initvalue);
      await this.updateDistrictRequest(this.change_district);
      router.push('/district/list');
    },
    onChangeDistrict(value, field){
      this.change_district[field] = value;
    },
  },
  computed: {
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('District', ['isReceiving']),
  },
  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'DistrictList' });
    this.edit_district = Object.assign({}, this.initvalue);
    if(this.regions.length==0) this.getRegionsRequest();
    if(this.townships.length==0) this.getTownshipsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
